import IntegrationIframe from './IntegrationIframe'

const abundanceEngineExports = {
  IntegrationIframe
}

export default abundanceEngineExports
